module.exports = __webpack_public_path__ + "static/img/cdfj4.a6b77cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardiobrain/cdfj4.png
// module id = CQiY
// module chunks = 5